var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper", attrs: { id: "login" } }, [
    _c("div", { staticClass: "login-content d-flex justify-content-center" }, [
      _c(
        "div",
        { staticClass: "inner d-flex flex-column justify-content-between" },
        [
          _c("img", {
            staticClass: "branding",
            attrs: { src: "/static/als-logo.png", al: "ALS Logo" }
          }),
          _vm._v(" "),
          !_vm.resetPassword
            ? _c("div", { staticClass: "login-form" }, [
                _c("h2", [_vm._v("Sign in to your account")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Enter your email and password below to access your account."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "text-danger mb-3",
                    attrs: { id: "errorMessage" }
                  },
                  [_vm._v(_vm._s(_vm.error))]
                ),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.login.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Email Address")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "usernameField",
                          tabindex: "1"
                        },
                        domProps: { value: _vm.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link btn-sm float-right",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.resetPassword = !_vm.resetPassword
                            }
                          }
                        },
                        [_vm._v("Forgot your password?")]
                      ),
                      _vm._v(" "),
                      _c("label", [_vm._v("Password")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          id: "passwordField",
                          tabindex: "2"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group mt-2" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: { id: "rememberme", name: "rememberme" },
                            model: {
                              value: _vm.rememberMe,
                              callback: function($$v) {
                                _vm.rememberMe = $$v
                              },
                              expression: "rememberMe"
                            }
                          },
                          [_vm._v("Remember Me")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.resetPassword
            ? _c("div", { staticClass: "reset-password" }, [
                _c("h2", [_vm._v("Forgot your password?")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Enter your email address below and we will send you an email to help you reset your password."
                  )
                ]),
                _vm._v(" "),
                _c("form", [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Email Address")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "usernameField" },
                      domProps: { value: _vm.username },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.username = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", id: "resetButton" },
                        on: { click: _vm.resetUserPassword }
                      },
                      [_vm._v("Reset Password")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary ml-2",
                        attrs: { type: "button", id: "cancelButton" },
                        on: {
                          click: function($event) {
                            _vm.resetPassword = !_vm.resetPassword
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "copyright-footer" }, [
            _vm._v(
              "© " +
                _vm._s(_vm.currentYear) +
                " Analytica Laboratories Limited T/A ALS NZ"
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "login-image" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group mt-3" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-block",
          attrs: { type: "submit", id: "loginButton", tabindex: "3" }
        },
        [_vm._v("Sign In")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26084dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26084dc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = VQs5
// module chunks = 1